import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from 'axios';
import Paginator from "../../components/Paginator";
import InnerNav from "../../components/InnerNav";
import Wrapper from "../../components/Wrapper";
// import { AiFillEdit, AiFillDelete } from "react-icons/ai";
import { FcSearch,FcDownload } from "react-icons/fc";
const Daysale = ()=>{
    const [daysale, setDaysale] = useState([]);
    const [page, setPage] = useState(1);
    const [lastPage, setLastPage] = useState(1);
    const [total, setTotal] = useState(0);
    const today = new Date().toLocaleDateString('en-CA');
    const [searchDate, setSearchDate] = useState(today)
    const [fileName,setFileName] = useState("");
    const [searchOption, setSearchOption] = useState("");
    const [isDate, setIsDate] = useState(false);
    const[isDateInt, setIsDateInt] = useState(0);
    const[searchValue,setSearchValue] = useState("");
    useEffect(() => {
        (
        async () => {

            const {data} = await axios.get(`daysale?page=${page}`);
            setDaysale(data.data);
            setLastPage(data.meta.last_page)
            setTotal(data.meta.total);

        }
        )();
    },[page]);

    const doSearch  = async (e)=>{
        
        const {data} = await axios.get(`daySaleSearch?page=${page}&date=${searchDate}&search_option=${searchOption}&search_value=${searchValue}&is_date=${isDateInt}`);
        setDaysale(data.data);
        setLastPage(data.meta.last_page);
       setTotal(data.meta.total);
    }

    const searchOptions = (e)=>{
       // console.log(e);
        if(e==="date"){
            setIsDate(true);
            setIsDateInt(1);
        }else{
            setIsDate(false);
            setIsDateInt(0);
        }
        setSearchOption(e);
    }

    const doDownload = async () => {
        const now = new Date();
        const epochTime = now.getTime(); 
        const epochTimeInSeconds = Math.floor(epochTime / 1000);
        setFileName("daySales" + epochTimeInSeconds);
        try {
            const { data } = await axios.post('download/daySale', {
                name:fileName,
                date:searchDate,
                is_date:isDate,
                search_option:searchOption,
                search_value:searchValue
            }, { responseType: 'blob' });
            const blob = new Blob([data], { type: 'text/csv' });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            console.error('Error downloading file:', error);
        }
    }

    const del = async (id) =>{
        if(window.confirm("Are you sure you want to delete this record?")){
            await axios.delete(`daysale/${id}`);
            setDaysale(daysale.filter((daysale) => daysale.id !== id));
        }
    }
    return (
        <Wrapper pageTitle={'Day Sales'}>
            <InnerNav createLink={'/daysaleCreate'} listLink={'/daysale'} />
                <div className="w-full overflow-hidden rounded-lg shadow-xs">
                    <div className="w-full overflow-x-auto">
                        
                    <div className="w-full overflow-x-auto bg-white text-right leading-10 text-gray-700 pr-2">  Page <span className="rounded-full bg-gray-700 text-white p-2">{page}</span>/{lastPage} Total Records: {total} </div>

                    <div className="flex items-center">
                    <label className="block text-sm mr-2">
                        <select  onChange={e => searchOptions(e.target.value)}  className="block w-48 p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input">
                            <option value="0">Select Search Option</option>
                            <option value="date"> Date</option>
                            <option value="trx_code"> Trx Code</option>
                            <option value="msisdn"> MSISDN</option>
                        </select>
                    </label>

                    {isDate && <label className="block text-sm mr-2">
                    
                    <input 
                        type="date" 
                        value={searchDate}
                        className="block w-48 p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input"
                        placeholder="Msisdn"
                        onChange={e => setSearchDate(e.target.value)} 
                    />
                </label>
                }
                    
            
                <label className="block text-sm mr-2">
                <input type="text"  className="block w-48 p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input"
                        placeholder="Enter value"  onChange={e => setSearchValue(e.target.value)} />   
                </label>
                <label className="block text-sm mr-2">
                    <button className="mr-2" onClick={doSearch}> <FcSearch title="Search " className="text-2xl"/> </button>
                </label>
                <label className="block text-sm mr-2">
                    <button onClick={doDownload}><FcDownload title="Download" className="text-2xl"/>  </button>
                </label>
    
</div>

                        <Paginator lastPage={lastPage} pageChanged={setPage} />
                        <table className="w-full whitespace-no-wrap">
                            <thead>
                                <tr className="text-xs font-semibold tracking-wide text-left text-gray-500 uppercase border-b dark:border-gray-700 bg-gray-50 dark:text-gray-400 dark:bg-gray-800" >
                                    <th className="px-4 py-3">#Ref </th>
                                    <th className="px-4 py-3">Date </th>
                                    <th className="px-4 py-3">Amount </th>
                                    <th className="px-4 py-3">TrxCode </th>
                                    <th className="px-4 py-3">StationId </th>
                                    <th className="px-4 py-3">Msisdn </th>
                                    <th className="px-4 py-3">Source </th>
                                    <th className="px-4 py-3">TillNo </th>
                                    <th className="px-4 py-3">TrxTime </th>
                                    <th className="px-4 py-3">PayMethod </th>
                                    <th className="px-4 py-3">AttendantId </th>
                                    <th className="px-4 py-3">TimeIn </th>
                                     {/* <th className="px-4 py-3">Action</th> */}
                                </tr>
                                </thead>
                                <tbody className="bg-white divide-y dark:divide-gray-700 dark:bg-gray-800" >
                                    {daysale.map((daysale)=>{
                                         return(
                                             <tr key={daysale.id} className="text-gray-700 dark:text-gray-400">
                                                 <td className="px-4 py-5">{daysale.id}</td>
                                                 <td className="px-4 py-3 text-sm">{daysale.date}</td>
                                                 <td className="px-4 py-3 text-sm">{daysale.amount}</td>
                                                 <td className="px-4 py-3 text-sm">{daysale.trx_code}</td>
                                                 <td className="px-4 py-3 text-sm">{daysale.station_id}</td>
                                                 <td className="px-4 py-3 text-sm">{daysale.msisdn}</td>
                                                 <td className="px-4 py-3 text-sm">{daysale.source}</td>
                                                 <td className="px-4 py-3 text-sm">{daysale.till_no}</td>
                                                 <td className="px-4 py-3 text-sm">{daysale.trx_time}</td>
                                                 <td className="px-4 py-3 text-sm">{daysale.pay_method}</td>
                                                 <td className="px-4 py-3 text-sm">{daysale.attendant_id}</td>
                                                 <td className="px-4 py-3 text-sm">{daysale.time_in}</td>
                                                 {/* <td className="flex px-4 py-3 text-sm"><Link className="btn btn-sm btn-outline-secondary px-5" to={`/daysale/${daysale.id}/edit`}><AiFillEdit/> </Link><span className="btn btn-sm btn-outline-secondary" onClick={()=>del(daysale.id)}> <AiFillDelete className="text-rose-500 text-lg"/></span></td> */}
                                             </tr>
                                         );
                                     })
                                 }
                            </tbody>
                        </table>
                    </div>
                    <Paginator lastPage={lastPage} pageChanged={setPage} />
                </div>
             </Wrapper>
         );
};
export default Daysale;